export default "__VITE_ASSET__Ce9nvq$v__"